module.exports = __webpack_public_path__ + "static/media/footerfixo.d7a2d13c.png";